import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IPool } from '../../../../interfaces';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

interface IAxiosResponse {
  totalCount: number;
  itemCount: number;
  pageCount: number;
  currentPage: number;
  limit: number;
  items: IPool[];
}

interface IRequestParams {
  title?: string;
  barcode?: string;
  vendor?: string;
  category?: string[];
  brand?: string[];
  vendorStockCode?: string;
  reason?: string[];
  state?: string;
  sort?: string;
  page?: number;
  limit: number;
}

enum Status {
  loading = 'loading',
  done = 'done',
  fail = 'fail',
}
interface IState {
  data: IPool[];
  totalCount?: number;
  itemCount?: number;
  pageCount?: number;
  currentPage?: number;
  limit?: number;
  status: Status | '';
  error: any;
}

const initialState: IState = {
  data: [],
  totalCount: 0,
  itemCount: 0,
  pageCount: 0,
  currentPage: 0,
  limit: 0,
  status: '',
  error: null,
};

export const getProductPoolList = createAsyncThunk('product-pool/list', async (params?: IRequestParams) => {
  const vendorId = store.getState().auth?.user?.vendor?.id;
  const res = await axios.get<IAxiosResponse>(`${VENDOR_MC_URL}/${vendorId}/product/pool/list`, { params });
  return res.data;
});

const productPoolSlice = createSlice({
  name: 'product-pool',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(getProductPoolList.pending, (state, action) => {
      state.status = Status.loading;
    });
    builder.addCase(getProductPoolList.fulfilled, (state, action) => {
      state.data = action.payload.items;
      state.currentPage = action.payload.currentPage;
      state.itemCount = action.payload.itemCount;
      state.limit = action.payload.limit;
      state.totalCount = action.payload.totalCount;
      state.pageCount = action.payload.pageCount;
      state.status = Status.done;
    });
    builder.addCase(getProductPoolList.rejected, (state, action) => {
      state.error = 'Product Pool List Error!';
      state.status = Status.fail;
    });
  },
});

export default productPoolSlice.reducer;
